@if (clubServ.minClubLevel(30)) {
  <div class="league-list">
    <label class="form-label">{{ "LEAGUES" | translate }}</label>
    <div class="league-list__pills">
      @for (league of leagueList; track league.leagueID) {
        <span
          class="league-list__pill"
          >
          <bv-icon class="league-list__pill-icon" name="leaderboard"></bv-icon>
          <span class="league-list__pill-name">{{ league.leagueName }}</span>
          @if (clubServ.clubStaff) {
            <button
              type="button"
              class="league-list__pill-remove"
              [disabled]="splitParent"
              (click)="removeLeague(league)"
              [attr.aria-label]="'Remove ' + league.leagueName"
              >
              <bv-icon name="close"></bv-icon>
            </button>
          }
        </span>
      }
      @if (clubServ.clubStaff && availLeagues.length) {
        <button
          type="button"
          class="league-list__add"
          [bvMenuTriggerFor]="addMenu"
          [disabled]="!manageRegistrations || splitParent"
          id="btn_tourn_settings_add_league"
          >
          <bv-icon name="add"></bv-icon>
          <span>{{ "ADD_LEAGUE" | translate }}</span>
        </button>
      }
      @if (clubServ.clubStaff && availLeagues.length && splitParent) {
        <span
          class="league-list__hint"
          >
          {{ "SPLIT_PARENT_LEAGUE_HINT" | translate }}
        </span>
      } @else if (clubServ.clubStaff && availLeagues.length && !manageRegistrations) {
        <span
          class="league-list__hint"
          >
          {{ "ADD_LEAGUE_REQUIRES_MANAGE_PLAYERS" | translate }}
        </span>
      }
      <bv-menu #addMenu>
        @for (league of availLeagues; track league.leagueID; let idx = $index) {
          <button
            bv-menu-item
            (click)="leagueSelect = idx; addLeague()"
            >
            <bv-icon name="leaderboard"></bv-icon>
            <span>{{ league.leagueName }}</span>
          </button>
        }
      </bv-menu>
      @if (!leagueList.length && !availLeagues.length) {
        <span class="league-list__empty">
          {{ "NO_LEAGUES" | translate }}
        </span>
      }
    </div>
  </div>
}
